import { Component, Input } from '@angular/core';
import { NavController, NavParams, ToastController, ModalController } from 'ionic-angular';
import { Globals } from '../../../../globals';
import { OrdersCoServices } from '../../../orders/services';
import { TranslateService } from '@ngx-translate/core';
import { TakeawayServices } from '../../../takeaway/services';
import { TPVServices } from '../../../tpv/services';
import { PosComboPage } from '../pos-combo/pos-combo';

/**
 * Generated class for the  page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-pos-menu',
  templateUrl: 'pos-menu.html',
})
export class PosMenuPage {

  @Input() origin: string;
  @Input() platform: string;
  @Input() element_type: string;
  @Input() element: any;

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public globals: Globals,
    public ordersCoServices: OrdersCoServices,
    public translate: TranslateService,
    public toastCtrl: ToastController,
    public takeawayServices: TakeawayServices,
    public tpvServices: TPVServices,
    public modalCtrl: ModalController) {
  }

  changeSelectMenuSelected(menu) {
   
    if (menu.style === 'combo') {
      this.ordersCoServices.is_combo = true;
      this.takeawayServices.is_combo = true;
    } else {
      this.ordersCoServices.is_combo = false;
      this.takeawayServices.is_combo = false;
    }

    if (this.origin === 'comandero') {
      this.ordersCoServices.section_select = 'Menu';
      this.ordersCoServices.section_menu_order = menu.sections[0].name;

      this.ordersCoServices.menu_select = menu.UID;
      //recargar el getmenus porque el async una vez descativado parte grafica no funciona
      this.ordersCoServices.getMenus(this.globals.restaurant_uid);
    } else {
      this.takeawayServices.section_menu_order = menu.sections[0].name;

      this.takeawayServices.menu_select = menu.UID;
      ////recargar el getmenus porque el async una vez descativado parte grafica no funciona
      this.takeawayServices.getMenus(this.globals.restaurant_uid);
    }
    
    

  }

  insertToTicketMenu(_name, _price, _delete, _count, _type, _uid) {
    this.tpvServices.deleteKeyboard();
    if (this.element.style == 'combo') {
      let profileModal = this.modalCtrl.create(PosComboPage,
        {
          combo: this.element,
          origin: 'tpv'
        });
      profileModal.onDidDismiss(data => { });
      profileModal.present();
    } else {
      this.tpvServices.insertTable(_name, _price, _delete, _count, _type, _uid, {});

      this.tpvServices.autoScrollEnterElements();
    }


  }

}



// WEBPACK FOOTER //
// ./src/pages/components/pos/pos-menu/pos-menu.ts